import { render, staticRenderFns } from "./TherapistLoading.vue?vue&type=template&id=6271ee87"
import script from "./TherapistLoading.vue?vue&type=script&lang=js"
export * from "./TherapistLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports